import { ExamType, RegistrationType } from '@report/graphql';

export const REGISTRATION_TYPE_LABEL = {
  [RegistrationType.InHouse]: 'In-house',
  [RegistrationType.Public]: 'Public',
} as const;

export const EXAM_TYPE_LABEL = {
  [ExamType.Paper]: 'Paper',
  [ExamType.Computer]: 'Computer',
} as const;

export const REGISTRATION_TYPE_OPTIONS = [
  { label: REGISTRATION_TYPE_LABEL[RegistrationType.Public], value: RegistrationType.Public },
  { label: REGISTRATION_TYPE_LABEL[RegistrationType.InHouse], value: RegistrationType.InHouse },
];

export const EXAM_TYPE_OPTIONS = [
  { label: EXAM_TYPE_LABEL[ExamType.Paper], value: ExamType.Paper },
  { label: EXAM_TYPE_LABEL[ExamType.Computer], value: ExamType.Computer },
];
